import React from "react";
import styles from "./order_graph.module.css";
import { changeShortDateFormat } from "../../utils/util_functions";


const OrderGraph = ({ order, selfieShipping }) => {

  const renderCancelGraph = () => {
    return (
      <div className={styles.gridCell}>
        <div className={`${styles.upString} red`}>Отменён</div>
        <div className={styles.downString}>{changeShortDateFormat(order.cancelled_date)}</div>
      </div>
    )
  }

  return (
    <>
      <div className={`${styles.graphic} ${selfieShipping && styles.graphic__4}`}>
        <div className={styles.gridCell}>
          <div className={styles.upString}>Создан</div>
          <div className={styles.downString}>{changeShortDateFormat(order.created_date)}</div>
        </div>
        {order.cancelled_date ?
          <>
            {order.invoiced_date ?
              <>
                <div className={styles.gridCell}>
                  <div className={styles.upString}>Выставлен<br />счёт</div>
                  <div className={styles.downString}>{changeShortDateFormat(order.invoiced_date)}</div>
                </div>
                {renderCancelGraph()}
              </>
              :
              <>
                {renderCancelGraph()}
              </>
            }
          </> :
          <>
            <div className={styles.gridCell}>
              <div className={styles.upString}>Выставлен<br />счёт</div>
              <div className={styles.downString}>{changeShortDateFormat(order.invoiced_date)}</div>
            </div>
            {
              !selfieShipping &&
              <div className={styles.gridCell}>
                <div className={styles.upString}>Отправлен</div>
                <div className={styles.downString}>{changeShortDateFormat(order.delivery_date)}</div>
              </div>
            }
            <div className={styles.gridCell}>
              <div className={styles.upString}>Ожидает<br />получения</div>
              <div className={styles.downString}>{changeShortDateFormat(order.await_receipt_date)}</div>
            </div>
            <div className={styles.gridCell}>
              <div className={styles.upString}>Получен</div>
              <div className={styles.downString}>{changeShortDateFormat(order.received_date)}</div>
            </div>
          </>
        }
      </div>
    </>
  );
};

export default OrderGraph;
